import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { allUsersSliceReducer } from '../slices/allUsersSlice';
import { allVideosSliceReducer } from '../slices/allVideosSlice';
import { challengesSliceReducer } from '../slices/challengesSlice';

export const store = configureStore({
  reducer: {
    allUsersSliceReducer,
    allVideosSliceReducer,
    challengesSliceReducer
  }
});

